import React from 'react';
import TableMobileItem from '../TableMobileItem';

const TableContentMobile = ({
  data
}) => {
  return /*#__PURE__*/React.createElement("div", null, data.map(item => /*#__PURE__*/React.createElement(TableMobileItem, {
    battle: item,
    key: item.timestamp
  })));
};

export default TableContentMobile;